import React, { useEffect, useState, useRef } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import BookIcon from "@mui/icons-material/Book";
import People from "@mui/icons-material/People";
import Public from "@mui/icons-material/Public";
import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import { FxmsData } from "../datas/FxData";
import {
  FxmsPopup,
  FxmsContentDashboardDialog,
  FxWindow,
} from "../windows/FxWindows";
import { FxResource } from "./../inputs/FxResource";
import { FxmsEvent } from "../actions/FxEvent";
import { FxButtonContent } from "./../inputs/FxButton";
import * as authAction from "../jwt/auth-action";
import { NavLink } from "react-router-dom";
import axios from "axios";

/**
 * 상단 탑 내용
 * 개발자 : T/F팀
 * 개발년월 : 2022.11
 * @returns
 */
const FxAppBar = (props) => {
  const { fxUiGrpItem, onMenuClick } = props;
  const [dashboards, setDashboards] = React.useState([]);
  const [account, setAccount] = React.useState(null);
  const [menuGroups, setMenuGroups] = React.useState([]);
  const [links, setLinks] = React.useState([]);
  const [title, setTitle] = React.useState("");
  const [logo, setLogo] = React.useState("");
  const [etcLinks, setEtcLinks] = useState([]);
  const [etcMenuGroups, setEtcMenuGroups] = useState(null);
  const [normalLinks, setNormalLinks] = useState([]);
  const grpCloseRef = React.useRef(null);
  const itemCloseRef = React.useRef(null);

  const showMenu = fxUiGrpItem.opObj
    ? fxUiGrpItem.opObj.getAttrValue("showMenuYn", true)
    : false;

  const clickDashboard = (uiGrpNo) => {
    if (uiGrpNo < 0) {
      FxWindow.alert("어떤 대시보드 화면인지 설정되지 않았습니다.");
    } else {
      localStorage.setItem("basUiGrpNo", uiGrpNo);
      document.location.href = "/";
    }
  };

  // 1. Bearer 방식 - window.open으로 변경
  const openHrefLink = async (link, name) => {
    try {
      // sso 토큰 요청
      const response = await axios.post(
        `https://sso.vup.co.kr/sso/issue`,
        {
          targetName: name,
          targetUrl: link,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const result = response.data;
      window.open(`${result.redirectUrl}?ssoToken=${result.token}`, "_blank");
      //새창열기로 변경 
      //window.location.href = `${result.redirectUrl}?ssoToken=${result.token}`;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        // 만료된 토큰
        window.open(link, "_blank");
      } else if (e.response && e.response.status === 404) {
        // SSO에 연결된 주소 없음
        window.open(link, "_blank");
      } else {
        alert("해당 사이트에 연결할 수 없습니다.");
      }
    }
  };

  // 2. url?token=... 방식 (1,2중 선택하여 주석)
  /*
  const openHrefLink = (link) => {
    const token = localStorage.getItem("FXMS-JWT");
    const url = new URL(link);
    url.searchParams.append("token", token);
  
    window.open(url.toString(), "_blank");
  }
  */

  // 대시보드 href
  const dashboardLink = (link) => {
    document.location.href = "/" + link;
  };

  // 대시보드 목록 추가
  // comp-app-bar 기능코드에 속성으로 설정된 내용으로 대시보드를 보여준다.

  function makeButton(attrList) {
    let datas = [];
    for (let attr of attrList) {
      if (attr.attrGrp !== "fixedValue") {
        continue;
      }
      const linkOp = FxmsData.getOpObj(attr.linkOpId);
      if (linkOp === undefined) {
        continue;
      }

      if (linkOp.uiCmptName === "DASHBOARD") {
        const uiGrpNo = linkOp.getAttrValue("uiGrpNo", -1);
        if (uiGrpNo > 0) {
          datas.push(
            <Button
              className="FxAppBarDashboardButton"
              key={uiGrpNo}
              onClick={function (event) {
                localStorage.setItem(
                  "attrEtcInfoObj",
                  JSON.stringify(attr.etcInfoObj)
                );
                clickDashboard(uiGrpNo);
              }}
            >
              {attr.attrUiTxt}
            </Button>
          );
        }
      } else if (linkOp.opTypeCd === "UI" || linkOp.opTypeCd === "COMPONENT") {
        // datas.push(<FxButtonContent key={attr.attrName} attr={attr} onClick={() => dashboardLink(attr.linkOpId)} />);
        datas.push(<FxButtonContent key={attr.attrName} attr={attr} />);
      }
    }
    return datas;
  }

  useEffect(() => {
    const attrList = fxUiGrpItem.opObj.attrList;

    setTitle(FxmsData.getVarValue("ui-title", "Virtual Utility Plant(운용)"));
    setLogo(FxmsData.getVarValue("title-icon", null));

    //대시보드, 타시스템 바로가기
    if (attrList !== undefined && attrList != null) {
      setDashboards(attrList.filter((attr) => attr.attrTypeCd == "DASHBOARD"));
      const hrefLinks = attrList.filter((attr) => attr.attrTypeCd == "href");
      setEtcLinks(hrefLinks);

      // FEMS와 일반 링크 분리
      if (hrefLinks && hrefLinks.length > 0) {
        const femsLink = hrefLinks.find((link) => link.attrUiTxt === "FEMS");
        const otherLinks = hrefLinks.filter(
          (link) => link.attrUiTxt !== "FEMS"
        );

        // 일반 링크 설정
        setNormalLinks(otherLinks);

        // FEMS 메뉴 그룹 설정
        if (femsLink) {
          const femsMenuGroup = {
            opId: femsLink.attrName,
            opTitle: femsLink.attrUiTxt,
            subMenuList: [
              {
                opId: "shihwa",
                opTitle: "시화도금단지",
                showPopup: false,
                uiCmptName: "HREF",
                attrDftVal: "https://siwha.vup-fems.kr/",
              },
              {
                opId: "incheon",
                opTitle: "인천표면처리센터",
                showPopup: false,
                uiCmptName: "HREF",
                attrDftVal: "https://incheon.vup-fems.kr/",
              },
              {
                opId: "ansan",
                opTitle: "안산분산열원",
                showPopup: false,
                uiCmptName: "HREF_SSO",
                attrDftVal: "http://119.195.248.210:18090/",
              },
            ],
          };

          setEtcMenuGroups(
            <FxAppBarMenuGroup
              key={femsLink.attrName}
              menuGroup={femsMenuGroup}
              menuName={femsLink.attrUiTxt}
              itemCloseRef={itemCloseRef}
              openHrefLink={openHrefLink}
            />
          );
        }
      }
    }

    // 메뉴 그룹 설정
    if (showMenu) {
      const menuList = FxmsData.getMenuList();
      let menuGroups = [];
      for (let menuGroup of menuList) {
        if (menuGroup.uiCmptName != "DASHBOARD") {
          menuGroups.push(
            <FxAppBarMenuGroup
              key={menuGroup.opId}
              menuGroup={menuGroup}
              menuName={menuGroup.opTitle}
              itemCloseRef={itemCloseRef}
              grpCloseRef={grpCloseRef}
            />
          );
        }
      }
      setMenuGroups(menuGroups);
    }

    // 계정 메뉴
    let opObj;
    const accountMenuGroup = {};
    accountMenuGroup.subMenuList = [];
    accountMenuGroup.subMenuList.push({ opId: "logout", opTitle: "Logout" });
    accountMenuGroup.subMenuList.push({ opId: "Divider" });

    /*개인정보수정*/
    opObj = FxmsData.getOpObj("ui-my-info-edit");
    if (opObj)
      accountMenuGroup.subMenuList.push({
        selectedData: FxmsData.user,
        icon: <Avatar />,
        showPopup: true,
        ...opObj,
      });

    /*접속암호변경*/
    opObj = FxmsData.getOpObj("ui-my-pwd-edit");
    if (opObj)
      accountMenuGroup.subMenuList.push({
        selectedData: FxmsData.user,
        icon: <Settings />,
        showPopup: true,
        ...opObj,
      });

    setAccount(
      <FxAppBarMenuGroup
        menuGroup={accountMenuGroup}
        menuName={FxmsData.getUser().userName}
        icon={<AccountCircle />}
        itemCloseRef={itemCloseRef}
      />
    );

    // 대시보드 목록 추가
    // comp-app-bar 기능코드에 속성으로 설정된 내용으로 대시보드를 보여준다.
    // try {
    //   let datas = makeButton(fxUiGrpItem.opObj.attrList);
    //   setDashboards(datas);
    // } catch (error) {
    //   console.log(error);
    // }
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }} className="FxAppBarBox">
      <AppBar position="static" className="FxAppBar">
        <Toolbar>
          {/* Appbar 좌측 프로젝트 이름 옆 햄버거 버튼(≡) 주석처리 */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={function (event) {
              onMenuClick();
            }}
          >
            <MenuIcon />
          </IconButton>
          {/* 사이트 아이콘 */}
          {/* <img src={logo} style={{ width: '45px', height: '45px' }}/> */}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
            className="Title"
            id="FXMS_SITE_NAME"
            onClick={function (event) {
              // 홈으로 이동
              localStorage.setItem("basUiGrpNo", 0);
              document.location.href = "/";
            }}
          >
            {title}
          </Typography>

          <div id="FXMS_NAVIGATOR" className="FxNavigator">
            <span></span>
          </div>

          {menuGroups}

          {/* 대시보드 */}
          {/* {dashboards} */}
          <Box sx={{ alignSelf: "center" }}>
            {dashboards.map((dashBoard) => (
              // <NavLink to={"/" + dashBoard.linkOpId}>
              //   <Button key={dashBoard.attrName}>
              //     {dashBoard.attrUiTxt}
              //   </Button>
              // </NavLink>
              <Button
                key={dashBoard.attrName}
                onClick={() => dashboardLink(dashBoard.linkOpId)}
              >
                {dashBoard.attrUiTxt}
              </Button>
            ))}
          </Box>

          {/* href 바로가기 */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* IMEX 버튼 */}
            {normalLinks.find((link) => link.attrUiTxt === "IMEX") && (
              <Button
                onClick={() =>
                  openHrefLink(
                    normalLinks.find((link) => link.attrUiTxt === "IMEX")
                      .attrDftVal,
                    "IMEX"
                  )
                }
              >
                IMEX
              </Button>
            )}

            {/* TOC 버튼 */}
            {normalLinks.find((link) => link.attrUiTxt === "TOC") && (
              <Button
                onClick={() =>
                  openHrefLink(
                    normalLinks.find((link) => link.attrUiTxt === "TOC")
                      .attrDftVal,
                    "TOC"
                  )
                }
              >
                TOC
              </Button>
            )}

            {/* FEMS 드롭다운 */}
            {etcMenuGroups}

            {/* TESS 버튼 */}
            {normalLinks.find((link) => link.attrUiTxt === "TESS") && (
              <Button
                onClick={() =>
                  openHrefLink(
                    normalLinks.find((link) => link.attrUiTxt === "TESS")
                      .attrDftVal,
                    "TESS"
                  )
                }
              >
                TESS
              </Button>
            )}

            {/* 3D 버튼 */}
            {normalLinks.find((link) => link.attrUiTxt === "3D") && (
              <Button
                onClick={() =>
                  openHrefLink(
                    normalLinks.find((link) => link.attrUiTxt === "3D")
                      .attrDftVal,
                    "3D"
                  )
                }
              >
                3D
              </Button>
            )}

            {/* MotorSense 버튼 */}
            {normalLinks.find((link) => link.attrUiTxt === "MotorSense") && (
              <Button
                onClick={() =>
                  openHrefLink(
                    normalLinks.find((link) => link.attrUiTxt === "MotorSense")
                      .attrDftVal,
                    "MotorSense"
                  )
                }
                sx={{ textTransform: 'none' }}
              >
                MotorSense
              </Button>
            )}
          </Box>
          {account}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

const FxAppBarMenuGroup = (props) => {
  const { menuGroup, menuName, icon, itemCloseRef, openHrefLink } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuItemList, setMenuItemList] = React.useState([]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    console.log("*** AppMenuItem, MenuGroup, openMenu 1 ***", menuGroup.opId);
  };
  const clickItem = (opId) => {
    openMenu(opId);
    setAnchorEl(null);
    console.log("*** AppMenuItem, MenuGroup, openMenu 2 ***", menuGroup.opId);
  };

  const openMenu = (opId) => {
    if (opId === "logout") {
      FxmsData.logout();
      authAction.logoutActionHandler();
    }
    console.log("*** AppMenuItem, MenuGroup, openMenu ***", menuGroup.opId);
  };

  useEffect(() => {
    console.log("*** AppMenuItem, MenuGroup ***", menuGroup.opId);

    let menus = [];
    let key;

    for (let menu of menuGroup.subMenuList) {
      key = menuGroup.opId + "_" + menu.opId;
      if (menu.opId === "Divider") {
        // menus.push(<Divider key={key} className="FxAppBarMenuItem" />);
        continue;
      } else if (menu.opId === "logout") {
        menus.push(
          <MenuItem
            id={menu.opId}
            onClick={function (event) {
              clickItem(menu.opId);
            }}
            key={key}
            className="FxAppBarMenuItem"
          >
            <ListItemIcon className="FxAppBarMenuItem">
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        );
      } else {
        menus.push(
          <AppMenuItem
            key={key}
            menu={menu}
            clickItem={openHrefLink ? openHrefLink : clickItem}
            selectedData={menu.selectedData}
            selectedDataId={menu.selectedDataId}
            itemCloseRef={itemCloseRef}
            showPopup={menu.showPopup}
          />
        );
      }
    }

    setMenuItemList(menus);
  }, []);

  return (
    <div id="test" className="FxAppBarMenuGroup">
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        className="FxAppBarMenuGroupIcon"
      >
        {icon ? icon : getIcon(menuGroup.iconName, null)}
        <Typography
          variant="button"
          display="block"
          className="FxAppBarMenuGroupText"
        >
          {menuName}
        </Typography>
      </IconButton>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="FxAppBarMenu"
      >
        {menuItemList}
        {/* <FxMenuList /> */}
      </Menu>
    </div>
  );
};

export const AppMenuItem = (props) => {
  const { menu, selectedData, selectedDataId, itemCloseRef, clickItem } = props;
  const [open, setOpen] = useState(false);

  console.log("*** AppMenuItem ***", props);

  const onClick = (event) => {
    // HREF 타입인 경우 직접 링크 열기
    if (menu.uiCmptName === "HREF" && menu.attrDftVal) {
      window.open(menu.attrDftVal, "_blank");
      return;
    }

    if (menu.uiCmptName === "HREF_SSO" && menu.attrDftVal) {
      clickItem(menu.attrDftVal, menu.opId);
      return;
    }

    // 다른 메뉴가 열려 있으면 닫는다.
    if (itemCloseRef.current) {
      itemCloseRef.current();
    }

    // 다른 메뉴가 선택되면 이 메뉴를 닫기위해 설정해 준다.
    itemCloseRef.current = function () {
      setOpen(false);
    };

    // 내 화면을 연다.
    setOpen(true);
    clickItem(menu.opId);
  };

  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {}, []);

  return (
    <>
      <MenuItem id={menu.opId} onClick={onClick} className="FxAppBarMenuItem">
        {/* <ListItemIcon className="FxAppBarMenuItem"> {getIcon(menu.iconName)}</ListItemIcon> */}
        {menu.opTitle}
      </MenuItem>
      {props.showPopup === true ? (
        <FxmsPopup
          open={open}
          closeModal={closeModal}
          title={menu.opTitle}
          opObj={menu}
        >
          <FxResource
            menu={menu}
            selectedData={selectedData}
            selectedDataId={selectedDataId}
          />
        </FxmsPopup>
      ) : (
        <FxmsContentDashboardDialog
          open={open}
          closeModal={closeModal}
          dialogTitle={menu.opTitle}
          opObj={menu}
        >
          <FxResource
            menu={menu}
            selectedData={selectedData}
            selectedDataId={selectedDataId}
          />
        </FxmsContentDashboardDialog>
      )}
    </>
  );
};

function getIcon(name, defIcon) {
  const icons = {
    InboxIcon: <InboxIcon />,
    SendIcon: <SendIcon />,
    BookIcon: <BookIcon />,
    DraftsIcon: <DraftsIcon />,
    People: <People />,
    Public: <Public />,
  };

  const ret = icons[name];
  return ret ? ret : defIcon ? icons[defIcon] : null;
}

export default FxAppBar;
